import { StepNode } from "./StepNode";
import { ThenEdge } from "./ThenEdge";
import { TriggerNode } from "./TriggerNode";

export const nodeTypes = { trigger: TriggerNode, step: StepNode };
export const edgeTypes = { then: ThenEdge };
